const Main = () => {
    return ( 
        <main>
            <div className="container">
                
                <div className="top-row">
                    <div className="top-text-col">
                        <h1 className="main-section-heading">
                            Boost The Growth of
                            <br />  <span className="bold-main-heading">
                                Your Startup Business
                            </span>
                        </h1>
                        <p className="description">
                            This should be used to tell a story and let your users know a little more about your product or service. How can you benefit them?
                        </p>
                        <ul className="main-section-list">
                            <li className="arrow-list-style">
                                Donec nec justo eget felis facilisis fermentum.
                            </li>
                            <li className="arrow-list-style">
                                Aliquam porttitor mauris sit amet orci.
                            </li>
                            <li className="arrow-list-style">
                                Integer vitae libero ac risus egestas placerat.
                            </li>
                        </ul>
                        <a href="/quote" className="btn-a">Get Quote</a>
                    </div>
                    <div className="img-main-box">
                        <img src="\assets\house.jpeg" className="main-top-row-img" alt="" />
                    </div>
                </div>

                <hr className="faded" />
                
                <div className="bottom-row">
                    <div className="bottom-text-col">
                        <h1 className="main-section-heading">
                            Boost The Growth of
                            <br /> <span className="bold-main-heading">
                                Your Startup Business
                            </span>
                        </h1>
                        <p className="description">
                            This should be used to tell a story and let your users know a little more about your product or service. How can you benefit them?
                        </p>
                        <ul className="main-section-list">
                            <li className="arrow-list-style">
                                Donec nec justo eget felis facilisis fermentum.
                            </li>
                            <li className="arrow-list-style">
                                Aliquam porttitor mauris sit amet orci.
                            </li>
                            <li className="arrow-list-style">
                                Integer vitae libero ac risus egestas placerat.
                            </li>
                        </ul>
                        <a href="/quote" className="btn-a">Get Quote</a>
                    </div>
                    <div className="img-main-box">
                        <img src="\assets\home4lifebanner.jpeg" className="main-bottom-row-img" alt="" />
                    </div>
                </div>
            
            </div>
        </main>
     );
}
 
export default Main;